export default "__VITE_ASSET__BGvIQBmk__"